import { ICoreContext } from '@msdyn365-commerce/core';
import React from 'react';
import { toast } from 'sonner';
import GetDocumentDownload, { GetDocumentDownloadInput } from '../actions/get-document-download.action';

export const getDocumentDownload = async (
    documentId: string,
    index: number,
    documentDownloadRef: HTMLAnchorElement,
    documentDownloadAlreadyDownloaded: number[],
    context: ICoreContext,
    resources: any
) => {
    try {
        const link = documentDownloadRef;

        // Download and initiate click()/download only once
        if (!documentDownloadAlreadyDownloaded.includes(index)) {
            const actionInput = new GetDocumentDownloadInput(documentId);
            const documentDownload = await GetDocumentDownload(actionInput, context.actionContext);
            const documentContent = `data:application/pdf;base64,${documentDownload.Content}`;
            // Only prepare link if content is available
            if (documentDownload.Content.length === 0) {
                toast.error(
                    <div className='toast' role='alert'>
                        <div className='toast-header'>
                            <h4>{resources.orderHistoryDownloadErrorHeading}</h4>
                            <button className='toast-close' onClick={() => toast.dismiss()}></button>
                        </div>
                        <div className='toast-body'>
                            <span>{resources.orderHistoryDownloadErrorNoContentDescription}</span>
                        </div>
                    </div>
                );
            } else {
                link.href = documentContent;
                link.download = documentDownload.FileName;
                documentDownloadAlreadyDownloaded.push(index);
                link.click();
            }
        }
    } catch (error) {
        toast.error(
            <div className='toast' role='alert'>
                <div className='toast-header'>
                    <h4>{resources.globalErrorHeading}</h4>
                    <button className='toast-close' onClick={() => toast.dismiss()}></button>
                </div>
                <div className='toast-body'>
                    <span>{resources.globalErrorServiceNotAvailable}</span>
                </div>
            </div>
        );
        return error;
    }

    return null;
};
